<ion-header [translucent]="false" class="ion-no-border custom-header" mode="md">
  <ion-toolbar>
    <ion-title class="modal-title">{{'edit_window_type' | translate}}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" class="ion-padding">
  <div class="configuration-container">
    <!-- <h2 class="modal-title">{{'edit_window_type' | translate}}</h2> -->

    <ion-list>
      <ng-container *ngFor="let obj of listData">
        <ion-item lines="none" class="cardDiv" (click)="selectOption(obj)"
          [ngClass]="obj['id'] == selectedOption?.id ? 'selected' : ''" *ngIf="(obj['name'] | translate)?.trim()">
          <div class="image-container">
            <img [src]="obj.img" class="square-image" />
          </div>
          <div class="content-container">
            <h5 class="card-title">{{obj.name | translate}}</h5>
            <p class="card-subtitle">{{obj.desc | translate}}</p>
          </div>
        </ion-item>
      </ng-container>
    </ion-list>
  </div>
</ion-content>
<ion-footer [translucent]="false" class="ion-no-border ">
  <div class="button-container">
    <ion-button fill="outline" class="cancel-btn" (click)="cancel()" expand="block">
      {{'cancel' | translate}}
    </ion-button>
    <ion-button class="next-btn" (click)="next()" [disabled]="!selectedOption" expand="block">
      {{'next' |translate}}
    </ion-button>
  </div>
</ion-footer>